module.exports = __webpack_public_path__ + "static/img/zhuanjie2.f892712.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/zhuanjie2.png
// module id = ANxa
// module chunks = 24